import { useEffect, useState } from 'react';

import { enqueueSnackbar } from 'notistack';

import httpInstances from '@/api/axiosInstance';
import copyToClipboard from '@/utils/copyToClipboard';
import { emailValidator } from '@/utils/validators';

const useShareButton = (code?: string, shareUrlOverride?: string) => {
  const [modalOpen, setModalOpen] = useState<boolean>(false);
  const [content, setContent] = useState<string>('');
  const [recipient, setRecipient] = useState<string>('');
  const [emailError, setEmailError] = useState<string>('');

  useEffect(() => {
    setContent('');
    setEmailError('');
    setRecipient('');
  }, [modalOpen]);

  let shareUrl: string; // TODO: test
  if (shareUrlOverride) {
    shareUrl = shareUrlOverride;
  } else {
    const { protocol, host } = window.location;
    shareUrl = code ? `${protocol}//${host}/${code}` : window.location.href;
  }

  const sendEmail = async () => {
    const errorMessage = emailValidator(recipient);
    if (errorMessage) {
      setEmailError(errorMessage);
      return;
    }
    try {
      enqueueSnackbar('Email is sending, please wait...', {
        variant: 'loading'
      });
      setModalOpen(false);
      await httpInstances.axiosGoInstance.post(`/share`, {
        content,
        recipient,
        url: shareUrl
      });
      enqueueSnackbar('Email sent!', {
        variant: 'success',
        autoHideDuration: 5000
      });
    } catch {
      enqueueSnackbar('Something went wrong!', {
        variant: 'error',
        autoHideDuration: 5000
      });
    }
  };
  const handleCopyToClipboard = () => {
    copyToClipboard(shareUrl, 'Link copied to clipboard!');
  };

  const handleChangeRecipient = (value: string) => {
    setEmailError('');
    setRecipient(value);
  };

  return {
    modalOpen,
    setModalOpen,
    content,
    setContent,
    recipient,
    handleChangeRecipient,
    handleCopyToClipboard,
    sendEmail,
    emailError
  };
};

export default useShareButton;
